module.exports = __webpack_public_path__ + "img/15.19d5504b.svg";